import { Typography, Container } from "@mui/material";
export const PoliticaPrivacitatPage = () => {
  return (
    <Container
      maxWidth="lg"
      sx={{
        mt: "64px",
        mb: "64px",
      }}
    >
      <Typography variant="h3" sx={{ mb: 3 }}>
        Política de privacitat
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        A BuscoPis ens prenem molt seriosament la privacitat dels nostres
        usuaris. Aquesta política de privacitat descriu com recopilem, utilitzem
        i protegim la informació personal que ens proporciones a través del
        nostre lloc web.
      </Typography>
      <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>
        Recollida d'informació
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Recopilem informació personal que ens proporciones voluntàriament quan
        utilitzes els nostres serveis, com ara el teu nom, adreça de correu
        electrònic i informació relacionada amb les teves preferències de cerca
        d'immobles.
      </Typography>
      <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>
        Ús de la informació
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Utilitzem la informació recopilada per oferir-te els nostres serveis,
        personalitzar la teva experiència i comunicar-nos amb tu. També podem
        utilitzar la informació per millorar el nostre lloc web i els nostres
        serveis.
      </Typography>
      <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>
        Compartició de la informació
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        No compartim la teva informació personal amb tercers, excepte quan sigui
        necessari per oferir els nostres serveis o quan la llei ho requereixi.
      </Typography>
      <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>
        Protecció de la informació
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Implementem mesures de seguretat adequades per protegir la teva
        informació personal contra l'accés no autoritzat, la pèrdua o la
        destrucció.
      </Typography>
      <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>
        Els teus drets
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Tens dret a accedir, rectificar o eliminar la teva informació personal
        en qualsevol moment. Si vols exercir aquests drets, posa't en contacte
        amb nosaltres.
      </Typography>
      <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>
        Canvis en aquesta política
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Ens reservem el dret de modificar aquesta política de privacitat en
        qualsevol moment. Qualsevol canvi serà publicat en aquesta pàgina.
      </Typography>
      <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>
        Contacte
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Si tens alguna pregunta sobre aquesta política de privacitat, pots
        contactar-nos a través del nostre correu electrònic: xxx@buscopis.com.
      </Typography>
    </Container>
  );
};
